<template>
  <section class="breakeven-percentage-for-bluffing-the-turn-table well">
    <table class="table">
      <thead>
        <tr>
          <th>Selected</th>
          <th>1/3</th>
          <th>1/2</th>
          <th>2/3</th>
          <th>3/4</th>
          <th>Full</th>
          <th>1.5x</th>
          <th>2x</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ breakevenPercentages[0] }}</td>
          <td>{{ breakevenPercentages[1] }}</td>
          <td>{{ breakevenPercentages[2] }}</td>
          <td>{{ breakevenPercentages[3] }}</td>
          <td>{{ breakevenPercentages[4] }}</td>
          <td>{{ breakevenPercentages[5] }}</td>
          <td>{{ breakevenPercentages[6] }}</td>
          <td>{{ breakevenPercentages[7] }}</td>
        </tr>
        <tr>
          <td>{{ dropoffPercentages[0] }}</td>
          <td>{{ dropoffPercentages[1] }}</td>
          <td>{{ dropoffPercentages[2] }}</td>
          <td>{{ dropoffPercentages[3] }}</td>
          <td>{{ dropoffPercentages[4] }}</td>
          <td>{{ dropoffPercentages[5] }}</td>
          <td>{{ dropoffPercentages[6] }}</td>
          <td>{{ dropoffPercentages[7] }}</td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
export default {
  name: 'breakeven-percentage-for-bluffing-the-turn-table',
  props: ['breakevenPercentages', 'dropoffPercentages']
};
</script>

<style lang="scss" scoped>
  .breakeven-percentage-for-bluffing-the-turn-table {
    overflow-x: scroll;
    padding: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/breakeven-percentage-for-bluffing-the-turn/breakeven-percentage-for-bluffing-the-turn-table.vue